<template>
  <div class="lz-field">
    <label class="lz-field-label">Receipt</label>
    <div v-if="uploading" class="lz-upload-status">
      <b-spinner small class="mr-2"></b-spinner>Uploading...
    </div>
    <b-form-file
      v-if="!uploadedFile && !uploading"
      drop-placeholder="Drop file here..."
      placeholder="Choose a file or drop it here..."
      ref="file"
      @change="uploadBill"
      :disabled="uploading"></b-form-file>
    <div v-if="uploadedFile && !uploading" class="lz-file-chip" :title="fileName">
      <b-icon icon="paperclip" class="mr-1"></b-icon>
      <span>{{ getUploadedFileName() }}</span>
      <b-link class="lz-file-remove" @click="removeUploadedFile()" title="Remove">
        <b-icon icon="x-circle-fill"></b-icon>
      </b-link>
    </div>
  </div>
</template>

<script>
import ServicesOld from '../../services/index.vue'
import Services from '../../services/main.service.vue'

export default {
  name: 'AttachmentSelector',
  data() {
    return {
      uploading: false,
      fileName: null,
      uploadedFile: null
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    file() {
      return this.FormData.file
    }
  },
  methods: {
    async uploadBill(ev) {
      try {
        this.uploading = true
        const { data, status } = await ServicesOld.UploadExpenseBill(
          ev.target.files[0]
        )
        if (status === 200) {
          this.fileName = ev.target.files[0].name
          this.uploadedFile = data.content.fileName
          this.$store.commit('modifyFormData', {
            key: 'file',
            value: this.uploadedFile
          })
        }
        this.uploading = false
      } catch (err) {
        console.log('issue-with-uploading-attachment:', err.message)
        this.fileName = null
        this.uploading = false
        this.uploadedFile = null
        this.$bvToast.toast(
          'There is an issue for uploading the attachement file, Please try again',
          {
            title: 'Error',
            variant: 'danger',
            solid: true
          }
        )
      }
    },
    async removeUploadedFile() {
      this.uploading = true
      const { status } = await ServicesOld.RemoveExpenseBill(this.uploadedFile)
      if (status === 200) {
        this.uploadedFile = null
        this.fileName = null
      }
      this.uploading = false
    },
    getUploadedFileName() {
      if (!this.uploadedFile) {
        return
      }
      let result = this.fileName
      if (result.length > 30) {
        let startStr = result.substr(0, 15)
        let endStr = result.substr(result.length - 10)
        result = `${startStr} ... ${endStr}`
      }
      return result
    }
  }
}
</script>

<style>
.custom-file-label {
  overflow: hidden !important;
  border-radius: 8px !important;
  border-color: #ced4da !important;
  font-size: 13.5px !important;
}
.form-file-text {
  line-height: 20px !important;
}
</style>

<style scoped>
.lz-upload-status {
  display: flex;
  align-items: center;
  font-size: 12.5px;
  font-weight: 600;
  color: #6c757d;
  padding: 9px 0;
}
.lz-file-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  background: #eef8fa;
  border: 1px solid #bfe7ec;
  color: #0f5f6b;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 12.5px;
  font-weight: 600;
}
.lz-file-chip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lz-file-remove {
  color: #dc3545;
  margin-left: 8px;
  line-height: 1;
}
.lz-file-remove:hover {
  color: #a71d2a;
}
</style>
